import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	cardsTitle: {
		id: 'company-hub.cards-extension.cards.hub-element.title',
		defaultMessage: 'Cards',
		description: 'A visible text label to be used as the title for the cards element',
	},
	cardsDescription: {
		id: 'company-hub.cards-extension.cards.hub-element.description',
		defaultMessage: 'Present links, images and more',
		description: 'A visible text label to be used as the description for the cards element',
	},
});
